export const POPUP_TYPE = {
  DEPOSIT: 'deposit',
  TRANSFER: 'transfer',
  WITHDRAW: 'withdraw',
  PRIVACY: 'privacy',
  TERMS: 'terms',
  POLICIES: 'policies',
  DESCLAMIER: 'desclamier',
};
